import type { LoginRefreshResponse } from '@/types/responses/loginRefreshResponse'

export const useAuth = () => {
  const clearCookies = () => {
    const authStore = useAuthStore()
    const petsDetailsStore = usePetsDetailsStore()
    const policyStore = usePolicyStore()

    authStore.$reset()
    petsDetailsStore.$reset()
    policyStore.$reset()
    // Note: userStore.$reset() is handled in logoutUser() via activePinia._s.forEach
    // to avoid race condition with cookie rehydration
  }

  const fetchRefreshToken = async (): Promise<boolean> => {
    const { refreshToken, setTokens } = useAuthStore()
    const { getPolicies, setSelectedPolicy } = usePolicyStore()

    if (!refreshToken) return false

    try {
      const { response } = useApiFetch('user/login/refresh', {
        method: 'POST',
        body: { refreshToken }
      })

      const { bearerToken, refreshToken: newRefreshToken }: LoginRefreshResponse = await response

      setTokens({ bearerToken, refreshToken: newRefreshToken })

      const policies = await getPolicies()

      if (policies.length) {
        setSelectedPolicy(policies[0])
      }

      return true
    } catch (error) {
      console.error('Error refreshing tokens:', error)

      return false
    }
  }

  const loginRedirect = async ({ redirectQuery = false }: { redirectQuery?: boolean } = {}): Promise<
    ReturnType<typeof navigateTo>
  > => {
    const route = useRoute()

    return navigateTo({
      path: '/login',
      ...(redirectQuery && !['/', '/login'].includes(route.path) ? { query: { redirect: route.fullPath } } : {})
    })
  }

  return {
    clearCookies,
    fetchRefreshToken,
    loginRedirect
  }
}
